<script setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { useStore } from "vuex";
import { CATEGORY_CODES } from "@/shared/lib/constants";

const { t } = useI18n();
const router = useRouter();
const store = useStore();

defineProps({
  links: {
    type: Array,
    default: () => [],
  },
  withBorder: {
    type: Boolean,
    default: false,
  },
  form: {
    type: Object,
    default: () => ({}),
  },
});

const notaryData = computed(() => {
  return store.getters.get_notary || {};
});

function getParticipantNames(list) {
  if (!Array.isArray(list)) return "";
  const formatName = (p) => {
    if (!p.first_name) return "";
    return (
      p.first_name +
      (p.last_name ? " " + `${p.last_name[0]}.` : "") +
      (p.middle_name ? " " + `${p.middle_name[0]}.` : "")
    );
  };
  return list
    .map((p) => formatName(p))
    .filter(Boolean)
    .join(", ");
}

function getLinkTitle(link) {
  return link?.info?.name || link?.info?.code || t("Не указано");
}

function isOwnAction(link) {
  return link.notary_uuid === notaryData.value.uuid;
}

function goToTransaction(link) {
  if (!isOwnAction(link)) return;

  let routeName = "notarial_action_view";

  if ([CATEGORY_CODES.SVID_PRAVO_NASLED].includes(link.category_code)) {
    routeName = "hereditary_case_view";
  }

  const routeData = router.resolve({
    name: routeName,
    params: { id: link.target_transaction_id },
  });

  window.open(routeData.href, "_blank");
}
</script>

<template>
  <div class="related-actions">
    <div v-if="links.length === 0" class="empty">
      {{ $t("Нет связанных действий") }}
    </div>
    <li
      v-else
      v-for="link in links"
      :key="link.id"
      class="item"
      :class="{
        'border border-solid border-border p-4 rounded-2xl': withBorder,
        'cursor-pointer hover:underline': isOwnAction(link),
        'cursor-default opacity-60': !isOwnAction(link),
      }"
      @click="goToTransaction(link)"
    >
      {{
        getLinkTitle(link) +
        (link.participants && link.participants.length
          ? ` (${getParticipantNames(link.participants)})`
          : "")
      }}
    </li>
  </div>
</template>

<style scoped lang="scss">
.related-actions {
  @apply flex flex-col gap-2.5;
}

.empty {
  @apply text-muted-foreground text-sm;
}

.item {
  @apply flex flex-col gap-2.5 text-muted-foreground text-sm font-medium;
  @apply list-none;
}
</style>
